const getNewWall = () => {
  return {
    resourceType: 'wall',
    resourceId: '',
    groupSettings: {
      name: '',
      description: null,
      icon: {
        image: null,
        imageBase: null
      },
      color: null,
      useColorAsBg: false,
    },
    displayType: 'full',
    popupLayout: 'column',
    collapseComments: false,
    showPostAuthorOnCompact: false,
    showUpvoteRatingOnCompact: false,
    commentSection: {
      initialCommentCount: 5
    },
    reactionType: 'unset', // 'standard', 'upvote'
  };
};

export default getNewWall;
